module.exports = __webpack_public_path__ + "img/enemy_122_003.26881bb5.png";